import axios from 'axios';
import { insertScript } from '@/util/helper';

const URL = {
  wx_sdk: '//res2.wx.qq.com/open/js/jweixin-1.4.0.js',
};
const API = {
  sign: `https://api.liuliangphone.com/widget/wechat/sign?refer=${encodeURIComponent(window.location.href)}`,
};

export default class Wx {
  private static async fetchConfig() {
    const data = (await axios.get(API.sign) || {}).data || {};
    console.log(data);
    return data.data || {};
  }

  public static bindShareTimeLine() {
    const {
      wx,
      SHARE,
      wxShareSuccessCallBack,
      wxShareErrorCallBack,
    } = window;
    wx.updateTimelineShareData({
      title: SHARE.title, // 分享标题
      link: SHARE.url, // 分享链接
      imgUrl: SHARE.icon_url, // 分享图标
      success: () => {
        if (wxShareSuccessCallBack) {
          wxShareSuccessCallBack();
        }
      },
      error: () => {
        if (wxShareErrorCallBack) {
          wxShareErrorCallBack();
        }
      },
    });
  }

  public static bindShare() {
    const {
      wx,
      SHARE,
      wxShareSuccessCallBack,
      wxShareErrorCallBack,
    } = window;
    wx.updateAppMessageShareData({
      title: SHARE.title, // 分享标题
      desc: SHARE.description, // 分享描述
      link: SHARE.url, // 分享链接
      imgUrl: SHARE.icon_url, // 分享图标
      success: () => {
        if (wxShareSuccessCallBack) {
          wxShareSuccessCallBack();
        }
      },
      error: () => {
        if (wxShareErrorCallBack) {
          wxShareErrorCallBack();
        }
      },
    });
  }

  public static init() {
    const wxSdkScript: HTMLElement = insertScript(URL.wx_sdk);
    wxSdkScript.onload = async () => {
      const config = await this.fetchConfig();
      const {
        wx,
        SHARE,
      } = window;
      wx.config({
        debug: false,
        appId: config.appId,
        timestamp: config.timestamp,
        nonceStr: config.nonceStr,
        signature: config.signature,
        jsApiList: ['checkJsApi',
          'updateTimelineShareData',
          'updateAppMessageShareData',
          'onMenuShareQQ',
          'onMenuShareWeibo',
          'hideMenuItems',
          'showMenuItems',
          'hideAllNonBaseMenuItem',
          'showAllNonBaseMenuItem',
          'translateVoice',
          'startRecord',
          'stopRecord',
          'onRecordEnd',
          'playVoice',
          'pauseVoice',
          'stopVoice',
          'uploadVoice',
          'downloadVoice',
          'chooseImage',
          'previewImage',
          'uploadImage',
          'downloadImage',
          'getNetworkGENRE',
          'openLocation',
          'getLocation',
          'hideOptionMenu',
          'showOptionMenu',
          'closeWindow',
          'scanQRCode',
          'chooseWXPay',
          'openProductSpecificView',
          'addCard',
          'chooseCard',
          'openCard',
        ],
      });
      wx.ready(() => {
        if (!SHARE) {
          return;
        }
        this.bindShare();
        this.bindShareTimeLine();
      });
    };
  }
}
